<template>
  <div class="register">
    <div class="header d-none d-sm-block">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="header mobile d-xs-block d-sm-none">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="body">

      <BusinessRegisterForm
        v-bind:private-info-label-text="pivateInfoLabelText"
        v-bind:public-info-label-text="publicInfoLabelText"
      />

      <div class="bottom-spacer"></div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
  import Footer from "../components/Footer";
  import BusinessRegisterForm from "../components/BusinessRegisterForm";
  import FloatingLogo from "../components/FloatingLogo";

  export default {
    name: "RegisterLocation",
    components: {
      FloatingLogo,
      BusinessRegisterForm,
      Footer,
    },

    data() {
      return {
        pivateInfoLabelText: "Información Privada",
        publicInfoLabelText: "Infomación Pública",
      }
    }

  };
</script>
<!--<style scoped type="less">-->
<!--</style>-->
